(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["carousel"] && !Shopify.designMode) return;
  try {
    function setUpCarousel(viewport) {
    var track = viewport.querySelector('[data-carousel-track]');
    var wrapper = viewport.closest('.carousel-block');
    if (!track || !wrapper) return;

    var prevButton = wrapper.querySelector('[data-carousel-prev]');
    var nextButton = wrapper.querySelector('[data-carousel-next]');

    var offset = 0;
    var maxOffset = 0;
    var slides = [];
    var positions = [];
    var dragging = false;
    var dragStartX = 0;
    var dragStartOffset = 0;
    var dragStartIndex = 0;
    var dragged = false;

    function clamp(value, min, max) {
      return Math.min(Math.max(value, min), max);
    }

    function apply(animate) {
      track.style.transition = animate ? 'transform 0.3s ease' : 'none';
      track.style.transform = 'translateX(' + -offset + 'px)';
    }

    function updateButtons() {
      var cutStart = maxOffset > 1 && offset > 1;
      var cutEnd = maxOffset > 1 && offset < maxOffset - 1;
      wrapper.classList.toggle('is-cut-start', cutStart);
      wrapper.classList.toggle('is-cut-end', cutEnd);
      if (!prevButton || !nextButton) return;
      prevButton.classList.toggle('is-disabled', !cutStart);
      nextButton.classList.toggle('is-disabled', !cutEnd);
    }

    function recalc() {
      slides = Array.prototype.filter.call(track.children, function (el) {
        return !el.classList.contains('carousel-track__spacer');
      });
      var firstSlide = slides[0];
      var lastSlide = slides[slides.length - 1];
      var lead = firstSlide ? firstSlide.offsetLeft - track.offsetLeft : 0;
      positions = slides.map(function (el) {
        return el.offsetLeft - firstSlide.offsetLeft;
      });
      var contentWidth = lastSlide
        ? lastSlide.offsetLeft - track.offsetLeft + lastSlide.offsetWidth + lead
        : track.scrollWidth;
      maxOffset = Math.max(0, contentWidth - viewport.clientWidth);
      offset = clamp(offset, 0, maxOffset);
      apply(false);
      updateButtons();
    }

    function goTo(value, animate) {
      offset = clamp(value, 0, maxOffset);
      apply(animate !== false);
      updateButtons();
    }

    function nearestSlideIndex(value) {
      var idx = 0;
      var best = Infinity;
      for (var i = 0; i < positions.length; i++) {
        var dist = Math.abs(Math.min(positions[i], maxOffset) - value);
        if (dist < best) {
          best = dist;
          idx = i;
        }
      }
      return idx;
    }

    if (prevButton) {
      prevButton.addEventListener('click', function (event) {
        if (prevButton.classList.contains('is-disabled')) return;
        event.preventDefault();
        var idx = Math.max(0, nearestSlideIndex(offset) - 1);
        goTo(positions[idx] || 0);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function (event) {
        if (nextButton.classList.contains('is-disabled')) return;
        event.preventDefault();
        var idx = Math.min(slides.length - 1, nearestSlideIndex(offset) + 1);
        goTo(idx in positions ? positions[idx] : maxOffset);
      });
    }

    track.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      if (event.target.closest('button, input, select, textarea, label')) return;
      dragging = true;
      dragged = false;
      dragStartX = event.clientX;
      dragStartOffset = offset;
      dragStartIndex = nearestSlideIndex(offset);
      track.style.transition = 'none';
    });

    track.addEventListener('pointermove', function (event) {
      if (!dragging) return;
      var delta = event.clientX - dragStartX;
      if (!dragged && Math.abs(delta) > 10) {
        dragged = true;
        track.setPointerCapture(event.pointerId);
      }
      offset = clamp(dragStartOffset - delta, 0, maxOffset);
      apply(false);
    });

    function endDrag() {
      if (!dragging) return;
      dragging = false;
      var moved = offset - dragStartOffset;
      var idx = dragStartIndex;
      if (moved >= 20) idx = Math.min(slides.length - 1, idx + 1);
      if (moved <= -20) idx = Math.max(0, idx - 1);
      goTo(idx in positions ? positions[idx] : maxOffset);
    }

    track.addEventListener('dragstart', function (event) {
      event.preventDefault();
    });

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);

    track.addEventListener(
      'click',
      function (event) {
        if (dragged) {
          event.preventDefault();
          event.stopPropagation();
          dragged = false;
        }
      },
      true
    );

    new ResizeObserver(recalc).observe(viewport);
    recalc();
  }

  document.querySelectorAll('[data-carousel-viewport]').forEach(setUpCarousel);
  } catch(e) { console.error(e); }
})();

})();
